export default __webpack_public_path__ + "static/media/bathing.2afdb03e.png";